import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../../../components/commons";
import { formatDate, handleDate, reverseDate } from "../../../utils/commonFunctions";
import { RootState } from "../../../redux/rootReducers";
import { resetSession } from "../../../redux/auth";
import { connect } from "react-redux";
import { getAllMasterDataBranchAction } from "../../../redux/masterData";
import { GetAllMasterDataBranchPayloadType } from "../../../commonTypes/masterDataTypes";
import useDebounce from "../../../customHooks/useDebounce";
import {
  emailTimesheetClientWiseTimeSheetReportAction,
  getClientWiseUserTimeSheetReportAction,
  resetClientWiseUserTimeSheetList,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
} from "../../../redux/timeSheet";
import { EmptyTimeSheetReportList } from "../../../assets/images";
import {
  EmailAllUserTimesheetReportPayloadType,
  EmailTimesheetVsSchedulingMonthlyReportType,
  GetTimeSheetSummaryClientWiseUserPayloadType,
} from "../../../commonTypes/timeSheetTypes";
import {
  ClientWiseUserTimeSheetType,
  EmployeeTimesheetType,
} from "../../../redux/timeSheet/timeSheetType";
import { ClientDirectoryListType } from "../../../redux/clientDirectory/clientDirectoryType";
import { GetClientDirectoryListPayloadType } from "../../../commonTypes/clientDirectoryTypes";
import { getClientDirectoryListAction } from "../../../redux/clientDirectory";
import TimeSheetClientWiseUserTable from "../../../components/TimeSheetReports/TimeSheetClientWiseUserTable.tsx/TimeSheetClientWiseUserTable";
import InfiniteLoader from "../../../components/commons/InfiniteLoader/InfiniteLoader";
import ScrollToTop from "../../../components/commons/ScrollToTop";
import TimeSheetClientWiseReportHeader from "../../../components/TimeSheetReports/TimeSheetSummaryReport/TimeSheetClientWiseReportHeader";
import toast, { Toaster } from "react-hot-toast";
export type DropDownUserType = {
  value: number | null;
  label: string;
};
type AppProps = {
  token: string | null;
  branchFetching: boolean;
  branchDataList: any;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  fetching: boolean;
  clientDirectoryList: [] | ClientDirectoryListType[];
  clientFetching:boolean;
  dispatchResettimeSheetClientWiseUserReport: () => void;
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => void;
  dispatchResetSession: () => void;
  dispatchGetTimeSheetClientWiseUserReportAction: (
    data: GetTimeSheetSummaryClientWiseUserPayloadType
  ) => void;
  dispatchResetTimeSheetSummaryClientWiseUserList: () => void;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchEmailClientWiseTimesheetReportAction: (
    data: EmailTimesheetVsSchedulingMonthlyReportType
  ) => void;
  timeSheetClientWiseUserReport: ClientWiseUserTimeSheetType;
  totalCount: number | null;
};
const TimSheetClientWiseUserReport = ({
  token,
  branchFetching,
  branchDataList,
  clientDirectoryList,
  clientFetching,
  timeSheetClientWiseUserReport,
  dispatchResetSession,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchGetTimeSheetClientWiseUserReportAction,
  dispatchResetTimeSheetSummaryClientWiseUserList,
  dispatchEmailClientWiseTimesheetReportAction,
  dispatchGetClientDirectoryListAction,
  totalCount,
  statusCode,
  success,
  error,
  message,
  fetching,
}: AppProps) => {
  const [startDate, setStartDate] = useState<string >("");
  const [endDate, setEndDate] = useState<string >("");
  const [offset, setoffset] = useState<number>(0);
  const [listOffset, setListOffset] = useState<number>(0);
  const [listLimit, setListLimit] = useState<number>(20);
  const [limit, setLimit] = useState<number>(20);
  const [text, setText] = useState<string>("");
  const [branchText, setBranchText] = useState<string>("");
  const [finalBranchDataList, setFinalBranchDataList] = useState<any>([]);
  const [branch, setBranch] = useState<DropDownUserType>({
    value: null,
    label: "Select..",
  });
  const [downloadFinalData, setDownloadFinalData] = useState({});
  const [showViewButton, setShowViewButton] = useState(false);
  const [data, setData] = useState<EmployeeTimesheetType[] | []>([]);
  const [currentStartDate, setCurrentStartDate] = useState<string>("");
  const [currentEndDate, setCurrentEndDate] = useState<string>("");
  const [showUserWithNotimesheetModal, setShowUserWithNotimesheetModal] =
    useState(false);
  const [finalClientList, setFinalClientList] = useState<
    DropDownUserType[] | []
  >([]);
  const [finalClient,setFinalClient]=useState<string>("")
  const [client, setClient] = useState<any>({
    label: "Select...",
    value: null,
  });
  const [clientOffset, setClientOffset] = useState(0);
  const [clientText, setClientText] = useState("");
  const [isOpen,setIsOpen]=useState(false)
  const [clientWiseUserReportUpdate, setClientWiseUserReportUpdate] = useState(false);

  const redirectedClientCode = localStorage.getItem("client_code");
  const redirectedStartDate = localStorage.getItem("start_date");
  const redirectedEndDate = localStorage.getItem("end_date");
  const redirectClientName= localStorage.getItem("client_name")

  useEffect(() => {
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetTimeSheetSummaryClientWiseUserList();
  

  }, []);

  useEffect(() => {
    if (timeSheetClientWiseUserReport?.data?.length === 0) {
      setData(timeSheetClientWiseUserReport?.data ? [...timeSheetClientWiseUserReport?.data?.map((item:EmployeeTimesheetType)=>({...item,isOpen}))] : []);
    }
    if (listOffset > 0) {
      setData((prv: any) => [...prv, ...timeSheetClientWiseUserReport?.data?.map((item:EmployeeTimesheetType)=>({...item,isOpen}))]);
    } else {
      setData(timeSheetClientWiseUserReport?.data ? [...timeSheetClientWiseUserReport?.data?.map((item:EmployeeTimesheetType)=>({...item,isOpen}))] : []);
    }
  }, [timeSheetClientWiseUserReport]);


    // Calling only while redirection from report
    useEffect(() => {
      if (redirectedClientCode &&redirectClientName &&redirectedStartDate&&redirectedEndDate) {
        if (token) {
          handleStartDateChange(redirectedStartDate?reverseDate(redirectedStartDate):'');
          handleEndDateChange(redirectedEndDate?reverseDate(redirectedEndDate):'');
          handleClientChange(redirectedClientCode,redirectClientName)
          
          let finalData: any = {
            token,
            offset: listOffset,
            limit: listLimit,
            start_date: redirectedStartDate,
            end_date: redirectedEndDate,
            client_code: redirectedClientCode,
          };
          setClientWiseUserReportUpdate(true)
          if (redirectedStartDate && redirectedEndDate) {
            dispatchGetTimeSheetClientWiseUserReportAction(finalData);

          }
          
        }
      }
    }, [redirectedClientCode,redirectClientName,redirectedStartDate,redirectedEndDate]);

  useEffect(() => {
    if (token) {
      if (startDate && endDate) {
        let finalData: any = {
          token,
          offset: listOffset,
          limit: listLimit,
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
          client_code: client?.value,
        };
        if (listOffset < +timeSheetClientWiseUserReport?.count) {
          dispatchGetTimeSheetClientWiseUserReportAction(finalData);
        } else if (listOffset === 0 && !timeSheetClientWiseUserReport?.count) {
          dispatchGetTimeSheetClientWiseUserReportAction(finalData);
        }
      }
    }
  }, [listOffset]);

  useEffect(()=>{
    let iterableData = JSON.parse(JSON.stringify(data));

    iterableData?.map((item: any) => {
      item.isOpen=isOpen
    });

    setData([...iterableData]);
  },[isOpen])

  useEffect(() => {
    const finalClientListData = clientDirectoryList?.map((data: any) => {
      return {
        value: data?.client_code,
        label: `${data?.company_name}(${data?.client_code})`,
      };
    });
    if (clientOffset > 0) {
      setFinalClientList([...finalClientList, ...finalClientListData]);
    } else {
      setFinalClientList(finalClientListData);
    }
  }, [clientDirectoryList]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        listOffset < (!!totalCount ? +totalCount : 0) &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (timeSheetClientWiseUserReport?.data?.length > 0) {
          if (!fetching && listOffset < +timeSheetClientWiseUserReport?.count) {
            setListOffset(listOffset + listLimit);
          }
        }
      }
    }
  };

  const handleExpandCollapse = (type: string) => {
    let iterableData = JSON.parse(JSON.stringify(data));

      if (type === "expand") {
        setIsOpen(true)
      }
      if (type === "collapse") {
        setIsOpen(false)
      }
  };


  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [timeSheetClientWiseUserReport]);

  useEffect(() => {
    if (token && totalCount) {
      if (clientOffset <= +totalCount) {
        const finalData = {
          token,
          status: 1,
          offset: clientOffset,
          limit: limit,
          searchValue: clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    }
  }, [clientOffset]);

  const fetchClientNewData = () => {
    const finalData = {
      token,
      status: 1,
      offset: clientOffset,
      limit: limit,
      searchValue: clientText,
    };
    dispatchGetClientDirectoryListAction(finalData);
  };

  useDebounce(
    () => {
      if (clientText) {
        fetchClientNewData();
      } else {
        const finalData = {
          token,
          status: 1,
          offset: clientOffset,
          limit: limit,
          searchValue: clientText,
        };
        dispatchGetClientDirectoryListAction(finalData);
      }
    },
    500,
    [clientText]
  );



  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
    localStorage.removeItem("start_date");
   
  
  };

  const handleBranchDropDownChange = (data: any) => {
    setBranch({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
    localStorage.removeItem("end_date");
  
  };
  const handleClientChange =(redirectedClientCode:any,redirectClientName:any)=>{
      setClient({
            value:redirectedClientCode,
            label:redirectClientName
          })
      localStorage.removeItem("client_name")
      localStorage.removeItem("client_code")


  }

  const handleSubmitData = () => {
    setFinalClient(client?.label?.split("(")[0])
    dispatchResetTimeSheetSummaryClientWiseUserList();
    setShowViewButton(true);
    setCurrentStartDate(startDate ? formatDate(startDate) : "");
    setCurrentEndDate(endDate? formatDate(endDate) : "");
    setIsOpen(false)
    window.scrollTo(0, 0);
    setData([]);
    if (token) {
      let finalData: GetTimeSheetSummaryClientWiseUserPayloadType = {
        token,
        limit: listLimit,
        offset: listOffset,
        start_date:startDate? formatDate(startDate) : "",
        end_date: endDate ? formatDate(endDate) : "",
        client_code: client?.value,
      };
      setDownloadFinalData(finalData);
      if (listOffset === 0) {
        dispatchGetTimeSheetClientWiseUserReportAction(finalData);
      } else {
        setListOffset(0);
      }
    }
  };
  const handleUserWithNoTimesheet = () => {
    setShowUserWithNotimesheetModal(!showUserWithNotimesheetModal);
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
              // dispatchResettimeSheetClientWiseUserReport();
            }}
          />
        );
      }
    }
    if (
      success === 1 &&
      message === "Billable and non-billable sums fetched successfully!"
    ) {
      dispatchResetTimeSheetReportMessage();
      dispatchResetTimeSheetReportSuccess();
    }
     if (
      success === 1 &&
      message === "Email has been sent successfully!"
    ) {
      toast.success("Email has been sent successfully!", {
        duration: 2000,
      });
      dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    }
    return false;
  };
  return (
    <div>
      <CommonHeader title="Client Wise Timesheet Report" />
      <div className="new-table-card">
        <div className="row">
          <div className="col-md-12 pl-2 pr-2 mt-4 mb-4">
          { 
          <div>
            <div
              className=""
              style={{
                display: "flex",
                alignItems: "center",
                marginTop: "-16px",
                marginBottom: "2px",
              }}
            >
              <div
                style={{ marginTop: "5px", marginLeft: "15px" }}
                className="mt-0 pt-2"
              >
                <span
                  className="ml-4"
                  style={{
                    fontWeight: "500",
                    letterSpacing: "0.34px",
                    fontSize: "16px",
                  }}
                >
                  Client Wise Timesheet Report
                </span>{" "}
              </div>
            </div>

            {!!timeSheetClientWiseUserReport?.data?.length ? <div
              
              style={{
                marginLeft: "40px",
                color: "#7c8db0",
                fontSize: "14px",
              }}
            >
              {`Total ${timeSheetClientWiseUserReport?.count} users found`}
            </div> : null}
           
          </div>
        }

            <TimeSheetClientWiseReportHeader
              startDate={startDate}
              endDate={endDate}
              handleStartDateChange={handleStartDateChange}
              handleEndDateChange={handleEndDateChange}
              handleSubmitData={handleSubmitData}
              setText={setText}
              setBranchText={setBranchText}
              branchFetching={branchFetching}
              clientFetching={clientFetching}
              finalBranchDataList={finalBranchDataList}
              setoffset={setoffset}
              limit={limit}
              handleBranchDropDownChange={handleBranchDropDownChange}
              branch={branch}
              showViewButton={showViewButton}
              handleUserWithNoTimesheet={handleUserWithNoTimesheet}
              timesheetSummaryReportList={timeSheetClientWiseUserReport?.data}
              token={token}
              downloadFinalData={downloadFinalData}
              currentStartDate={currentStartDate}
              currentEndDate={currentEndDate}
              type={"clientWiseUserReport"}
              client={client}
              setClient={setClient}
              setClientOffset={setClientOffset}
              setClientText={setClientText}
              finalClientList={finalClientList}
              dispatchEmailClientWiseTimesheetReportAction={dispatchEmailClientWiseTimesheetReportAction}
            />
          </div>
        </div>

        <div>

          <hr className="mt-1 mb-4"/>

         {(!!timeSheetClientWiseUserReport?.data?.length && (!!currentStartDate && !!currentEndDate))? <div>
          <h3 className="text-center">{finalClient}</h3>
          <div className="pt-1" style={{textAlign:"center",fontWeight:600,fontSize:"15px",color:"#6c757d"}}>
          {`${currentStartDate}  To  ${currentEndDate}`}
         </div></div> : null}

        {!!timeSheetClientWiseUserReport?.data?.length ? <div className="mr-2 mb-2" style={{ display: "flex", alignItems: "center", gap: "12px", flexDirection:"row-reverse" }}>
          
          <div
            className="collapse-open"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleExpandCollapse("collapse")}
          >
            Collapse All
          </div>
          <div
            className="collapse-open"
            style={{ cursor: "pointer", color: "red" }}
            onClick={() => handleExpandCollapse("expand")}
          >
            Expand All
          </div>
        </div> : null}
        </div>

       
       

        <>
          {fetching && listOffset === 0 ? (
            <TableLoader Rows={10} ColumnPerRow={7} />
          ) : data?.length > 0 ? (
            <TimeSheetClientWiseUserTable
              timeSheetClientWiseUserReport={timeSheetClientWiseUserReport}
              data={data}
              setData={setData}
            />
          ) : (
            <>
              {!fetching && (!data || data?.length === 0) && (
                <div className="pb-4 pl-0 pr-0">
                  <EmptyListPage
                    title="No Client Wise Timesheet List!"
                    text={
                      !currentStartDate && !currentEndDate
                        ? "Choose client , start date and end date  to get client wise timesheet  report"
                        : ""
                    }
                    imageWidth="30%"
                    image={EmptyTimeSheetReportList}
                    showAddButton={false}
                  />
                </div>
              )}
            </>
          )}
           {fetching && listOffset > 0 && <div>{<InfiniteLoader />}</div>}
                <div style={{ display: fetching ? "none" : "inline" }}>
                  <ScrollToTop />
                </div>
        </>
      </div>
      <Toaster/>

      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  totalCount: state.clientDirectory.totalCount,
  branchFetching: state.masterData.fetching,
  branchDataList: state.masterData.masterDataListing,
  masterDataBranchListTotal: state.masterData.masterDataBranchListTotal,
  timeSheetClientWiseUserReport: state.timeSheet.clientWiseUserTimeSheetList,
  clientDirectoryList: state.clientDirectory.clientDirectoryList,
  clientFetching: state.clientDirectory.fetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetReportStatusCode: () =>
    dispatch(resetTimeSheetStatusCode()),
  dispatchGetClientDirectoryListAction: (
    data: GetClientDirectoryListPayloadType
  ) => dispatch(getClientDirectoryListAction(data)),
  dispatchGetAllMasterDataBranchListAction: (
    data: GetAllMasterDataBranchPayloadType
  ) => {
    dispatch(getAllMasterDataBranchAction(data));
  },
  dispatchGetTimeSheetClientWiseUserReportAction: (
    data: GetTimeSheetSummaryClientWiseUserPayloadType
  ) => dispatch(getClientWiseUserTimeSheetReportAction(data)),
  dispatchResetTimeSheetSummaryClientWiseUserList: () =>
    dispatch(resetClientWiseUserTimeSheetList()),
  dispatchEmailClientWiseTimesheetReportAction: (
    data: EmailTimesheetVsSchedulingMonthlyReportType
  ) => dispatch(emailTimesheetClientWiseTimeSheetReportAction(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TimSheetClientWiseUserReport);
